// ============================================================
//  CONFIGURACIÓN DE FIREBASE
//
//  Reemplaza los valores de abajo con los de TU proyecto.
//  Los copias de: Firebase Console > ⚙️ Configuración del
//  proyecto > "Tus apps" > app web > bloque "firebaseConfig".
// ============================================================
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAlHbEvIrt1LC8jx4Ns5OsE3VMtkSgn2_E",
  authDomain: "banosdeaguasanta-1c3cc.firebaseapp.com",
  projectId: "banosdeaguasanta-1c3cc",
  storageBucket: "banosdeaguasanta-1c3cc.firebasestorage.app",
  messagingSenderId: "24661868831",
  appId: "1:24661868831:web:c5d910575c0870a0bb702a",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
